import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { useMediaTypeOptions } from "@shared/options";

export function SectorForm() {
  const translate = useTranslate();
  const { getMediaTypeOptions } = useMediaTypeOptions();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("book_sector_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="type"
          label={translate("book_sector_admin.fields.type")}
          options={getMediaTypeOptions()}
          required
        />
      </Grid>
    </Grid>
  )
}
